import { useMsal } from "@azure/msal-react";
import { IonButton, IonCard, IonCardContent, IonContent } from "@ionic/react";
import { loginRequest } from "../../api/authConfig";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";


function SignIn({ history }: any) {
    const { instance, accounts } = useMsal();
    const { t } = useTranslation();

    async function signIn() {
        await instance.loginRedirect(loginRequest)
            .catch(e => { console.error(e); });
    }

    useEffect(() => {
        if (accounts.length > 0) {
          // User is authenticated, navigate to the landing page
          history.push('/landing');
        }
      }, [accounts, history]);
    

    return (
        <IonContent fullscreen>
            <IonCard style={{
                textAlign: "center",
                position: "absolute",
                left: 0,
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
            }}>
                <IonCardContent>
                <IonButton onClick={signIn}>{t("login.signIn")}</IonButton>
                </IonCardContent>
            </IonCard>
        </IonContent>
    )

}

export default SignIn;
